import {Action} from "@/model/action";
import {Api} from "@/util/api";

export class ActionCollection {

    /**
     * Cached actions per action id.
     */
    private actionMap: Map<string, Action> = new Map();

    /**
     * Inflight promises (requests) per action id.
     */
    private promises: Map<string, Promise<Action>> = new Map();

    get(id: string): Promise<Action> {
        let action: Action | undefined = this.actionMap.get(id);
        if (undefined !== action) {
            //console.log("Got action with id=" + id + " from cache");
            return Promise.resolve(action);
        }
        return this.load(id);
    }

    load(id: string): Promise<Action> {
        let promise: Promise<Action> | undefined = this.promises.get(id);
        if (undefined !== promise) {
            //console.log("Returning inflight action promise for id=" + id);
            return promise;
        } else {
            //console.log("Loading action for id=" + id);
            promise = Api.getInstance().getActionById(id)
                .then(
                    action => {
                        this.actionMap.set(id, action); // add action to map
                        this.promises.delete(id);       // remove inflight promise for this action
                        return Promise.resolve(action);
                    }
                );
            this.promises.set(id, promise); // save inflight
            return promise;
        }
    }

}